import { gql } from '@apollo/client'

export const duplicateAndTranslateCourseMutation = gql`
  mutation DuplicateAndTranslateCourse  ($courseId: String!, $courseDuplicate: CourseDuplicate!, $toLanguage: String!, $organizationId: String!) {
    duplicateAndTranslateCourse (courseId: $courseId, courseDuplicate: $courseDuplicate, toLanguage: $toLanguage, organizationId: $organizationId) {
      id
      testCompanyId
    }
  }
`